import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { DeleteCaseSavedList } from "../api.js";

// The shape of the API's response
type DeleteCaseListResult = {
  status: string;
  message?: string;
  errorCode?: string;
};

// What the hook's caller will pass in
type DeleteCaseListPayload = {
  filterType: string;
  filterListName: string;
};

export const usePostCaseDeleteList = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation<
    DeleteCaseListResult, // data
    unknown, // error
    DeleteCaseListPayload & { token: string } // variables
  >({
    // sends DELETE /deleteCaseFilterList
    mutationFn: async ({
      filterType,
      filterListName,
      token,
    }) => {
      return DeleteCaseSavedList(
        { filterType, filterListName },
        token
      );
    },

    onSuccess: (data) => {
      // e.g. show a toast or invalidateQueries(...)
    },
    onError: (error) => {
      // handle/report errors
    },
  });

  const mutate = useCallback(
    async (
      payload: DeleteCaseListPayload,
      options?: {
        onSuccess?: (data: DeleteCaseListResult) => void;
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      return mutation.mutateAsync(
        { ...payload, token },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate };
};
